import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { PortableHeader } from 'src/components/PortableHeader/PortableHeader';
import WebFormContactUs from 'src/components/WebFormContactUs/WebFormContactUs';

export const ContactFormSection = ({ header }) => (
  <Container fluid className="bg-shapes-black-mountain bg-gray-800 px-0 py-6">
    <Container>
      <Row>
        <Col xs={12} md={{ span: 8, offset: 2 }} lg={{ span: 6, offset: 3 }}>
          <Col xs={12} className="text-center">
            <PortableHeader className="text-white" content={header} />
          </Col>
        </Col>
      </Row>
    </Container>
    <Container fluid className="active animate_base animate_fadeInUp px-0">
      <WebFormContactUs />
    </Container>
  </Container>
);
